import React from 'react';
import styled from 'styled-components';
import Container from '../components/ui/Container';

const Section = styled.section`
  padding: 6rem 0;
  position: relative;
`;

// Content box with semi-transparent background
const ContentBox = styled.div`
  border-radius: 8px;
  padding: 2.5rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  color: #333;
`;

const Content = styled.div`
  font-size: 1.1rem;
  line-height: 1.7;
  color: #555;
  
  p {
    margin-bottom: 1.5rem;
  }
`;

const About = () => {
  return (
    <Section>
      <Container>
        <ContentBox>
          <PageTitle>About Us</PageTitle>
          <Content>
            <p>
              We believe robots shouldn't just be functional—they should bring delight to every 
              space they enter. We're creating more than advanced mobile robotics platforms; 
              we're crafting personalities with precision engineering that make people smile.
            </p>
            <p>
              Founded by a team of robotics enthusiasts who were tired of cold, impersonal 
              machines, we set out to prove that technical excellence and joyful design can 
              coexist perfectly. Our robots combine sophisticated neural networks with expressive 
              movement patterns that feel organic and engaging.
            </p>
          </Content>
        </ContentBox>
      </Container>
    </Section>
  );
};

export default About;